/**
 * Class representing a FeInput.
 */
export default class FeInput {
  /**
    * Resets the value of the input element with the given id.
    * @param {string} id - The id of the input element to reset.
    */
  resetValue(id: string) {
    // Get the input element by id
    const input = document.getElementById(id) as HTMLInputElement;
        
    // If the input element exists, reset its value
    if (input) {
      input.value = '';
    }
  }
}
